import React from 'react'
import {Icon} from '@chakra-ui/react'

const AccountIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M38.0536 39.2075C37.543 39.2075 37.1268 38.8008 37.1079 38.2901C37.089 37.7321 36.4175 24.6716 19.8767 24.6716C3.33595 24.6716 2.89146 37.7038 2.89146 38.2617C2.89146 38.7819 2.46588 39.2075 1.94573 39.2075C1.42558 39.2075 1 38.7819 1 38.2617C1 38.1104 1.21752 22.7802 19.8862 22.7802C38.5549 22.7802 38.9994 38.082 38.9994 38.2334C39.0183 38.7535 38.6022 39.1885 38.082 39.2075C38.0726 39.2075 38.0631 39.2075 38.0536 39.2075Z"
                fill="currentColor"
            />
            <path
                d="M19.8857 23.5273C13.6723 23.5273 8.62207 18.4771 8.62207 12.2636C8.62207 6.05019 13.6723 1 19.8857 1C26.0991 1 31.1493 6.05019 31.1493 12.2636C31.1493 18.4771 26.0991 23.5273 19.8857 23.5273ZM19.8857 2.89146C14.722 2.89146 10.5135 7.09049 10.5135 12.2636C10.5135 17.4368 14.722 21.6358 19.8857 21.6358C25.0494 21.6358 29.2579 17.4368 29.2579 12.2636C29.2579 7.09049 25.0494 2.89146 19.8857 2.89146Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default AccountIcon
